import React from "react";
import { Outlet } from "react-router-dom";

/*
  Component to manage the entire PILOTS section
*/
function Pilots() {
  return <Outlet />;
}

export default Pilots;
